import type { FC } from 'react'
import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import AuthLayout from '../../layouts/AuthLayout'
import ForgotPasswordPage from '../../pages/ForgotPasswordPage'
import LoginPage from '../../pages/LoginPage'

import { EnumGlobalRoutes } from './routerConstants'

const AuthRoutes: FC = () => (
    <Routes>
        <Route element={<AuthLayout />}>
            <Route path={EnumGlobalRoutes.LOGIN} element={<LoginPage />} />
            <Route
                path={EnumGlobalRoutes.FORGOT_PASSWORD}
                element={<ForgotPasswordPage />}
            />
            <Route path="*" element={<Navigate to="/login" replace />} />
        </Route>
    </Routes>
)

export default AuthRoutes
